import { render, staticRenderFns } from "./FormDetailUiModal.vue?vue&type=template&id=a73d0740&scoped=true&"
import script from "./FormDetailUiModal.vue?vue&type=script&lang=js&"
export * from "./FormDetailUiModal.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailUiModal.vue?vue&type=style&index=0&id=a73d0740&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73d0740",
  null
  
)

export default component.exports